import { render, staticRenderFns } from "./UserDepartmentsSlimList.vue?vue&type=template&id=2e39a4b4"
import script from "./UserDepartmentsSlimList.vue?vue&type=script&lang=js"
export * from "./UserDepartmentsSlimList.vue?vue&type=script&lang=js"
import style0 from "./UserDepartmentsSlimList.vue?vue&type=style&index=0&id=2e39a4b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports